import { render, staticRenderFns } from "./DwTotalMembersByIndividualPlan.vue?vue&type=template&id=6080654c&"
import script from "./DwTotalMembersByIndividualPlan.vue?vue&type=script&lang=js&"
export * from "./DwTotalMembersByIndividualPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports